import { cva, type VariantProps } from 'class-variance-authority';
import { ReactElement } from 'react';
import { twMerge } from 'tailwind-merge';

const badge = cva(
  [
    'inline-flex',
    'items-center',
    'gap-1',
    'rounded-full',
    'px-2',
    'py-1',
    'text-xs',
    'font-medium',
    'font-inter',
    'whitespace-nowrap',
  ],
  {
    variants: {
      intent: {
        success: ['bg-emerald-50', 'text-emerald-700'],
        warning: ['bg-amber-50', 'text-amber-700'],
        info: ['bg-blue-50', 'text-primary'],
        neutral: ['bg-gray-100', 'text-gray-600'],
        danger: ['bg-red-50', 'text-red-700'],
      },
    },
    defaultVariants: {
      intent: 'neutral',
    },
  }
);

export interface BadgeProps extends VariantProps<typeof badge> {
  label: string;
  icon?: ReactElement;
  className?: string;
}

export function Badge({ label, icon, intent, className }: BadgeProps) {
  return (
    <span className={twMerge(badge({ intent }), className)}>
      {icon && (
        <span aria-hidden='true' className='shrink-0'>
          {icon}
        </span>
      )}
      {label}
    </span>
  );
}
